import { useContext, forwardRef } from "react";
import { AddressContext } from "../contexts/AddressContext";
import { ParameterContext } from "../contexts/ParameterContext";

import { Wish } from "./Wish";

export const DropdownSetAddresses = forwardRef(({ formData, wishChangeHandler, removeWish, isEdit, cleanSiblingInputFields, onBlurWishHandler, addWish }, ref) => {
    const { advSchools } = useContext(AddressContext);
    const { parameters } = useContext(ParameterContext);

    const messageParam = parameters.nomParameters.find(x => x.param_name == 'DESIRES_MESSAGE');

    return (
        <>
            <div ref={ref} className="htext_ch">Училища</div>
            <div className="children_data d-flex flex-wrap flex-col gap-1 mb-2 p-3-mob">
                <div className="d-flex w-100 justify-content-between">
                    <p className="school-child-address"><b>Постоянен адрес:</b> {formData.permanentChildCity} {formData.permanentAddress ? formData.permanentAddress.name : ''} {formData.permanentAddressInfo ? formData.permanentAddressInfo.addressNumber : ''}</p>
                    <p className="text-right-mob w-35-mob"><b>Регистриран на:</b> {formData.permanentAddressDate ? formData.permanentAddressDate.toLocaleDateString('bg-BG', { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''}</p>
                </div>
                <div className="d-flex w-100 justify-content-between">
                    <p className="school-child-address"><b>Настоящ адрес:</b> {formData.currentChildCity} {formData.currentAddress ? formData.currentAddress.name : ''} {formData.currentAddressInfo ? formData.currentAddressInfo.addressNumber : ''}</p>
                    <p className="text-right-mob w-35-mob"><b>Регистриран на:</b> {formData.currentAddressDate ? formData.currentAddressDate.toLocaleDateString('bg-BG', { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''}</p>
                </div>
                {messageParam?.value &&
                    <div className="d-flex w-100 justify-content-between">
                        <p className="school-child-address w-100">{messageParam?.value}</p>
                    </div>
                }
            </div>
            <div className="children_data d-flex flex-wrap gap-1 mb-2 p-3-mob">
                <p className="pa-na-color"><b>Училища за които имате предимство по ПА и НА: </b></p>
                {advSchools.length > 0 && advSchools.map(x => <p className="pa-na-color">{x.name}; </p>)}
            </div>
            <div className="children_data">
                {formData.wishes.map((x, i) =>
                    <Wish
                        formData={formData}
                        handleChange={wishChangeHandler}
                        wish={x}
                        key={x.id}
                        index={i}
                        removeWish={removeWish}
                        isEdit={isEdit}
                        cleanSiblingInputFields={cleanSiblingInputFields}
                        onBlurWishHandler={onBlurWishHandler}
                    />)}
                <div className="w-100 d-flex gap-3">

                    <div className="flex-col flex-wrap mt-3 ">
                        <button id="" className="btn but_add mb-3 mt-3" onClick={addWish}>Добави желание</button>
                    </div>

                </div>

            </div>
        </>
    )
})